<nb-layout windowMode>
	<nb-layout-header fixed>
		<ngx-header></ngx-header>
	</nb-layout-header>
	<nb-layout-column>
		<ng-content select="router-outlet"></ng-content>
	</nb-layout-column>
</nb-layout>
